import arrayParser from "../arrayParser"

const hoarsenessProcessor=(element)=>
{
let assembledElement = " unexplained hoarseness"

if (element["Description:"] !== "")
    {

     let voiceChange =[]
     let pitchChange = false //controls add on of pitch chance to sentence
     voiceChange.push(...element["Description:"])

    if (voiceChange.includes("pitch change"))
        {   
        pitchChange = true
        if (voiceChange.length === 1)
            { 
            assembledElement += " with a change in voice pitch"
            pitchChange = false
            }
        voiceChange.pop()
        }

    if (voiceChange.length !== 0)
        {
        assembledElement += ` with a ${arrayParser(voiceChange)} voice`
        }

    if (pitchChange)
        {
        assembledElement += " and a change in voice pitch"
        }
    }

if (element["Pain:"] !== "")
    {
        assembledElement +=` ${(element["Any_other_features"] === "" ? " with " : ", ")}${element["Pain:"].toLowerCase()}`
    } 

 if (element["Any_other_features"] !== "")
    {
    assembledElement += ` and ${element["Any_other_features"]}`
    }

if (element["Frequency:"]!== "" || element["Present_for_several:"] !== "")
    {
        assembledElement += ` which has been present ${element["Frequency:"].toLowerCase() } ${(element["Present_for_several:"] !== "" ? `for several  ${element["Present_for_several:"].toLowerCase()}` : "")}`
    }
 
return (assembledElement)
}

export default hoarsenessProcessor